import React from "react";
import { Modal, Form, Row, Col, Button, Input } from "antd";
import _ from "lodash";

const FormItem = Form.Item;

export default class AddAndFoundDoctorModalView extends React.Component {
  /**
   * @function showDoctorDetail
   * @param "selectedDoctor", "phoneNumber"
   * @desc This function handles displaying doctor detail string, shows detail string according to available data, i.e. name, speciality and phone number
   */
  showDoctorDetail = (selectedDoctor, phoneNumber) => {
    let detailString = "";
    if (selectedDoctor.name) {
      detailString = selectedDoctor.name;
    }
    if (detailString && selectedDoctor.speciality) {
      detailString = `${detailString} | ${selectedDoctor.speciality}`;
    }
    if (detailString && phoneNumber) {
      detailString = `${detailString} | ${phoneNumber}`;
    } else {
      detailString = phoneNumber;
    }
    return detailString;
  };

  render() {
    const {
      openFoundDoctorModal,
      openAddDoctorModal,
      closeAddDoctorModal,
      saveDoctorInfo,
      selectedDoctor,
      isProcessing,
      onChangePhone,
      fees,
      name,
      pph,
      phoneNumber,
      notFound,
      errorMsg,
      addDoctor,
      modalTitle,
      inviteDoctor,
      onChangePph,
      onChangeName,
      setFees
    } = this.props;

    return (
      <Modal
        className="kc-modal-medium no-footer form-type-modal"
        title={modalTitle}
        visible={openAddDoctorModal}
        onCancel={closeAddDoctorModal}
        maskClosable={false}
        footer={null}
      >
        <Form>
          <Row type="flex" gutter={16}>
            <Col lg={12} md={14} sm={24}>
              <FormItem
                className="remove-colon-lbl"
                label={`${"Search doctor by phone number"}`}
                required
              >
                <Input
                  max="11"
                  size="small"
                  type="number"
                  onChange={onChangePhone}
                  value={phoneNumber}
                  placeholder={"Enter Mobile number"}
                />
              </FormItem>
            </Col>
          </Row>

          {notFound && (
            <>
              <Row type="flex" gutter={16}>
                <Col lg={14} md={16} sm={24}>
                  <div className="error appt-error text-left mb-10 ">
                    {errorMsg}
                  </div>
                </Col>
              </Row>

              <Row type="flex" gutter={16}>
                <Col lg={12} md={14} sm={24}>
                  <FormItem
                    className="remove-colon-lbl"
                    label={`${"Name"}`}
                    required
                  >
                    <Input
                      size="small"
                      onChange={onChangeName}
                      value={name}
                      placeholder={"Name"}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row type="flex" gutter={16}>
                <Col lg={5} md={8} sm={24}>
                  <FormItem
                    className="remove-colon-lbl"
                    label={`${"Fees"}`}
                    required
                  >
                    <Input
                      size="small"
                      type="number"
                      onChange={setFees}
                      value={fees}
                      placeholder={"Fees"}
                    />
                  </FormItem>
                </Col>
                <Col lg={7} md={10} sm={24}>
                  <FormItem
                    className="remove-colon-lbl"
                    label={`${"Patients per hour"}`}
                    required
                  >
                    <Input
                      size="small"
                      type="number"
                      onChange={onChangePph}
                      value={pph}
                      placeholder={"Patients per hour"}
                    />
                  </FormItem>
                </Col>
              </Row>
            </>
          )}
        </Form>

        {openFoundDoctorModal && !_.isEmpty(selectedDoctor) && (
          <Form>
            <FormItem
              className="remove-colon-lbl mb-0"
              label={"Do you want to add?"}
            />
            {/* <FormItem
                className="remove-colon-lbl"
                label={`${selectedDoctor.name} | ${
                  selectedDoctor.speciality
                }| ${phoneNumber}`}
              /> */}
            <div className="doctor-info-lbl">
              {this.showDoctorDetail(selectedDoctor, phoneNumber)}
            </div>
          </Form>
        )}
        {/* buttons */}
        <Row className="modal-footer-row">
          <Col span={24}>
            <Button
              type="primary"
              htmlType="submit"
              size="small"
              onClick={
                selectedDoctor
                  ? addDoctor
                  : notFound
                  ? () => inviteDoctor(phoneNumber)
                  : saveDoctorInfo
              }
              loading={isProcessing}
              disabled={phoneNumber.length < 10}
            >
              {selectedDoctor
                ? modalTitle
                : notFound
                ? "Invite"
                : "Find Doctor"}
            </Button>
            <Button type="link" onClick={closeAddDoctorModal}>
              {"Cancel"}
            </Button>
          </Col>
        </Row>
      </Modal>
    );
  }
}
